import { useEffect, useState } from "react";
import styled from "styled-components";
import { Track, EventScheme, ProductScheme } from "client-v2";
import { useNavigate } from "react-router";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";

import Header from "../../components/section/Header";
import Resume from "./section/Resume";
import Info from "./section/Info";
import { Text, Color, Label, ColorV2 } from "@adoptaunabuelo/react-components";
import Container from "../../components/container/Container";
import CrossSell from "../../components/section/CrossSell";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

const Col = styled.div`
	display: flex;
	flex-direction: column;
`;

const Detail = (props: Props) => {
	const dispatch = useDispatch();
	const { setShowSuccess } = bindActionCreators(actionsCreators, dispatch);
	const loading = useSelector((state: State) => state.modals.loading);
	const currentUser = useSelector((state: State) => state.user.currentUser);

	const navigate = useNavigate();
	const [pastDue, setPastDue] = useState(false);

	useEffect(() => {
		//Track to Mixpanel
		Track.event({
			event: "event view init",
			user: currentUser,
			params: {
				view: "event",
				productId: props.product.objectId,
			},
		});

		const pastDue = props.product.startDate
			? dayjs() > dayjs(props.product.startDate.iso)
			: false;
		setPastDue(pastDue);
	}, []);

	const onShareClick = (op: any) => {
		const url =
			"https://adoptaunabuelo.org/evento/?id=" + props.product.objectId;
		if (op.id === "twitter") {
			window.open("http://www.twitter.com/share?url=" + url, "_blank");
		} else if (op.id === "facebook") {
			window.open("http://www.facebook.com/sharer.php?u=" + url);
		} else if (op.id === "whatsapp") {
			window.open("whatsapp://send?text=" + url);
		} else if (op.id === "url") {
			navigator.clipboard.writeText(url);
			setShowSuccess({
				show: true,
				message: "Se ha copiado el enlace en tu portapapeles",
			});
		}
	};

	const onNextClick = () => {
		Track.event({
			event: "event progress init",
			user: currentUser,
			params: {
				view: "event",
			},
		});
		navigate("/evento/registro?id=" + props.product.objectId, {
			state: {
				event: props.event,
				product: props.product,
			},
		});
	};

	return (
		<>
			<Container
				loading={loading}
				headerProps={{
					user: currentUser,
				}}
				style={{ backgroundColor: "white" }}
				RightView={
					<Resume
						event={props.event}
						product={props.product}
						onClick={onNextClick}
						onShareClick={onShareClick}
					/>
				}
				footerProps={{
					style: {
						backgroundColor: "white",
						borderTop: "1px solid " + ColorV2.border.neutralSoft,
					},
					buttonProps: {
						children: "Reservar",
						disabled: pastDue,
						onClick: onNextClick,
					},
					childrenPosition: "left",
					children: (
						<Col style={{ marginRight: 8 }}>
							{pastDue ? (
								<Label
									text="Evento finalizado"
									color={Color.status.color.error}
									style={{
										backgroundColor:
											Color.status.color.errorDefault,
										marginBottom: 4,
									}}
								/>
							) : (
								<Text type="p" weight="medium">
									{props.product.price > 0
										? props.product.price + "€ por persona"
										: "Evento gratuito"}
								</Text>
							)}
							<Text type="p2" style={{ color: Color.text.high }}>
								{dayjs(props.product.startDate?.iso)
									.locale("es")
									.format("D MMM YYYY [a las] ")}{" "}
								{dayjs(props.product.startDate?.iso).format(
									"HH:mm"
								)}
							</Text>
						</Col>
					),
				}}
			>
				<Helmet>
					<title>{props.product.title + " | Adopta Un Abuelo"}</title>
					<meta
						name="description"
						content={props.event.description.substring(0, 150)}
					/>
					<meta
						name="keywords"
						content={"adopta, un, abuelo, evento"}
					/>
					<meta
						property="og:title"
						content={props.product.title + " | Adopta Un Abuelo"}
					/>
					<meta
						property="og:description"
						content={props.event.description.substring(0, 150)}
					/>
					<meta
						property="og:image"
						content={props.event.image?.url}
					/>
					<meta
						property="og:url"
						content={
							"https://adoptaunabuelo.org/evento/?id=" +
							props.product.objectId
						}
					/>
				</Helmet>
				<Header event={props.event} product={props.product} />
				<Info event={props.event} product={props.product} />
			</Container>
			<CrossSell />
		</>
	);
};
export default Detail;
export interface Props {
	product: ProductScheme;
	event: EventScheme;
}
